import React from "react";
import ContentPageTemplate from "../components/ContentPageTemplate";
import { industryPages } from "../data/industryPages";

export default function WebdesignFuerHandwerker() {
  return <ContentPageTemplate {...industryPages.handwerker} />;
}
